import { Button, Modal, ModalContent, ModalFooter } from "monday-ui-react-core"
import { Upload } from 'react-bootstrap-icons'
import UploadTemplate from '../../template/energilitydx-upload-template.csv'

const UploadStatementsModalComponent = ({
    showModal, 
    closeModal, 
    inputFileRef, 
    selectedFile,
    uploadError, 
    handleFileInputClick, 
    handleUploadClick
}) => {
    return (
        <Modal
            id="story-book-modal"
            onClose={closeModal}
            show={showModal}
            title={' '}
        >
            <ModalContent>
                <div className="d-flex align-items-center">
                    <Upload size={20} className="mb-2" />
                    <h3 className="upload-file-title">
                        Upload file
                    </h3>
                </div>
                <>
                    <p>
                        First download the template by clicking
                        the following link
                    </p>
                    <a
                        href={UploadTemplate}
                        download="energilitydx-upload-template.csv"
                        target="_blank"
                        rel="noreferrer"
                        className="upload-template"
                    >
                        EnergilityDX - Product Balancing API and
                        Upload
                    </a>
                    <br />
                    <br />
                    <p>
                        After filling in the required fields in
                        the template, upload the file in CSV or
                        Excel format
                    </p>
                    <input
                        type="file"
                        onChange={handleFileInputClick}
                        ref={inputFileRef}
                    />
                    {uploadError !== '' && (
                        <p className="upload-error-message">
                            {uploadError}
                        </p>
                    )}
                </>
            </ModalContent>
            <ModalFooter>
                <div className="d-flex justify-content-end align-items-center">
                    <Button
                        onClick={closeModal}
                        className="cancel-modal-button"
                    >
                        Cancel
                    </Button>
                    <div>
                        {uploadError === '' && selectedFile && (
                            <Button onClick={handleUploadClick}>
                                Upload file
                            </Button>
                        )}
                    </div>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default UploadStatementsModalComponent